import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, MobilePopup, Popup, TextArea } from 'fasoo-ui-component-next';

import './RemarkPopup.scss';
import { AllApprovalDetailEntity } from '.';

interface RemarkPopupPros {
  isReject: boolean;
  open: boolean;
  onClose: (type: string) => void;
  onSubmit: (remark: string) => void;
  entity: AllApprovalDetailEntity | null;
}

const RemarkPopup: React.FC<RemarkPopupPros> = ({ isReject, open, onClose, onSubmit, entity }) => {
  const { t } = useTranslation(['commons', 'userApproval']);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  //   const [remark, setRemark] = useState<string>('');
  const [approverRemark, setApproverRemark] = useState<string>('');
  useEffect(() => {
    if (entity !== undefined && entity !== null && !pageLoad) {
      setPageLoad(true);
    }
  }, [entity, pageLoad]);

  const handleOnClose = (type: string): void => {
    onClose(type);
    setApproverRemark('');
  };

  const handleSubmit = (type: string): void => {
    onSubmit(approverRemark);
  };

  const handleChangeRemark = (value: string): void => {
    if (value.length <= 256) {
      setApproverRemark(value);
    }
  };

  return (
    <MobilePopup
      title={
        isReject === false
          ? t('userApproval:remarkPopup.approval.$')
          : t('userApproval:remarkPopup.reject.$')
      }
      open={open}
      onClose={() => handleOnClose(isReject === false ? 'approval' : 'reject')}
      footer={
        <React.Fragment>
          <Button
            classes="mobile-popup-button cancel"
            text={t('commons:cancel')}
            onClick={() => handleOnClose(isReject === false ? 'approval' : 'reject')}
          />
          <Button
            classes={classNames('mobile-popup-button', {
              confirm: isReject === false,
              reject: isReject === true,
            })}
            text={
              isReject === false
                ? t('userApproval:remarkPopup.approval.approveOk')
                : t('userApproval:remarkPopup.reject.rejectOk')
            }
            onClick={() => handleSubmit(isReject === false ? 'approval' : 'reject')}
          />
        </React.Fragment>
      }
    >
      <div>
        <p className="pb-13">
          {isReject === false
            ? t('userApproval:remarkPopup.approval.reason')
            : t('userApproval:remarkPopup.reject.reason')}
        </p>
        <div>
          <TextArea
            height={100}
            maxLength={256}
            classes="text-area-background"
            placeholder={
              isReject === false
                ? t('userApproval:remarkPopup.approval.help')
                : t('userApproval:remarkPopup.reject.help')
            }
            value={approverRemark}
            onChange={(e) => handleChangeRemark(e.target.value)}
          />
        </div>
        <div className="print-text-length">{`(${approverRemark.length}/256)`}</div>
      </div>
    </MobilePopup>
  );
};

export default RemarkPopup;
